export default () => {
  let banner = document.querySelector(".alert-banner");
  if(banner) {
    if(localStorage.getItem("AlertBanner")) {
      banner.classList.add("alert-banner--dismissed");
    }
  }

  let dismissButton = document.querySelector(".js-dismiss-alert-banner");
  if(dismissButton) {
    dismissButton.addEventListener("click", (e) => {
      localStorage.setItem("AlertBanner", "dismissed");
      banner.classList.add("alert-banner--dismissed");
    });
  }
};
